var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 36,
    stroke: "currentColor",
    strokeWidth: 3,
    opacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 22 62 A 36 36 0 0 1 78 62",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArco);
export default __webpack_public_path__ + "static/media/arco.319d2c9570a778ecc1a80591827c24c6.svg";
export { ForwardRef as ReactComponent };